export default "__VITE_ASSET__fe382cb5__"